import { Typography, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

type RequiredDocumentsTotalProps = {
    currentCount: number;
    totalCount: number;
    additionnalText?: string;
};
const RequiredDocumentsTotal: React.FunctionComponent<RequiredDocumentsTotalProps> = function ({
    currentCount = 0,
    totalCount = 0,
    additionnalText,
}) {
    const { palette } = useTheme();

    const color = useMemo(() => {
        if (totalCount > 0 && totalCount === currentCount) {
            return palette.success.main;
        }
        if (totalCount > 0 && currentCount > 0) {
            return palette.warning.main;
        }
        if (totalCount > 0 && currentCount === 0) {
            return palette.error.main;
        }
        return 'text.gris50';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCount, totalCount]);
    return (
        <Typography
            component="p"
            variant="l2dbodyxs"
            sx={{ color }}
        >
            {currentCount}/{totalCount} {additionnalText}
        </Typography>
    );
};

export default RequiredDocumentsTotal;
